/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ValidateIsrcRequest
 */
export interface ValidateIsrcRequest {
    /**
     * ISRC to check for duplicates
     * @type {string}
     * @memberof ValidateIsrcRequest
     */
    isrc: string;
}

/**
 * Check if a given object implements the ValidateIsrcRequest interface.
 */
export function instanceOfValidateIsrcRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "isrc" in value;

    return isInstance;
}

export function ValidateIsrcRequestFromJSON(json: any): ValidateIsrcRequest {
    return ValidateIsrcRequestFromJSONTyped(json, false);
}

export function ValidateIsrcRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ValidateIsrcRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'isrc': json['isrc'],
    };
}

export function ValidateIsrcRequestToJSON(value?: ValidateIsrcRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'isrc': value.isrc,
    };
}

